import React ,{ useState, useContext, useEffect }from "react";
import Button from "../elements/Button/Button";
import RadioInput from "../elements/RadioInput/RadioInput";
import Textinput from "../elements/TextInput/TextInput";
import { AuthContext } from "../../context/AuthContext";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import RequestModal from "./RequestModal";
const Pricing = () =>{

    const [selectedOption, setSelectedOption] = useState("");
    const { token } = useContext(AuthContext);
    const [selectedOptionPremium, setSelectedOptionPremium] = useState("");
    const [isReqPending, setIsReqPending] = useState(false);
    const [userPlan, setUserPlan] = useState();
    const [requestedPlan, setRequestedPlan] = useState();
    const [downGradePlan , setDowngradablePlan] = useState();
    const handlePlan = async () => {
        const encryptedMetadata = localStorage.getItem('metadata');
        const decryptedMetadata = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadata, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
        const user_id = decryptedMetadata.uid;
        const PlanUpgrade = {
            user_id: user_id,
        };
        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(PlanUpgrade),
            process.env.REACT_APP_SECRETKEY
        ).toString();
    
        const encryptjson = { data: encryptedData };
        try {
            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(`${serverURL}/subscription/getPendingApprovals`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    token: token
                },
                body: JSON.stringify(encryptjson)
            });
    
            const responsedata = await response.json();
            const decryptedData = JSON.parse(CryptoJS.AES.decrypt(responsedata.data, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
    
            if (!response.ok) {
                throw new Error(responsedata.error || "Something went wrong");
            }
    
            console.log("Updated Subscription Data:", decryptedData);
            if(decryptedData?.currentPlanDetails?.plans_id){
                setUserPlan(decryptedData?.currentPlanDetails?.plans_id);
            }
            if(decryptedData?.pendingApprovals[0]?.subscription?.status?.toLowerCase() === "pending"){
                setIsReqPending(true);
                setRequestedPlan(decryptedData?.pendingApprovals[0]?.subscription?.plan_id);
            }
            if(decryptedData?.downgrade){
                setDowngradablePlan(Object.keys(decryptedData?.preSubscription));
            }
    
        }catch(err) {
            console.log(err);
        }
    }
    useEffect(() => {
        handlePlan();
    },[])
    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleChangePremium = (event) => {
        setSelectedOptionPremium(event.target.value);
    };
    const [planDetails, setPlanDetails] = useState([]);
    const fetchPlanDetails = async () => {
        try {
            const secretKey =  process.env.REACT_APP_SECRETKEY;
            const serverURL = process.env.REACT_APP_SERVER_URL
            const encryptedMetadataAll = localStorage.getItem('metadata');
            const decryptedMetadataAll = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadataAll, secretKey).toString(CryptoJS.enc.Utf8));
            const uid = decryptedMetadataAll.uid;
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({ uid }), secretKey).toString();
            const response = await fetch(`${serverURL}/subscription/getPlans`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    token: token,
                },
                body: JSON.stringify({ data: encryptedData}),
            });

            const data = await response.json();
            const decryptedData = JSON.parse(
                CryptoJS.AES.decrypt(data.data, secretKey).toString(CryptoJS.enc.Utf8)
            );

            if (decryptedData) {
                setPlanDetails(decryptedData);
                console.log("Plan Details:", decryptedData);
            }
        } catch (err) {
            console.log("Error:", err);
        }
    };
    useEffect(() => {
        fetchPlanDetails();
    },[])

    const handleUpgradeSubs = async (plan,downgrade) => {
        const planType = plan;
        console.log(planType);
        if(isReqPending){
            return;
        }
    
        const encryptedMetadata = localStorage.getItem('metadata');
        const decryptedMetadata = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadata, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
        const user_id = decryptedMetadata.uid;
        const past_plan = decryptedMetadata.plan_id;
        const cid = decryptedMetadata.cid;
        let plan_type = "Upgrade";
        if(userPlan > plan){
            plan_type = "Downgrade";
        }
    
        const confirmUpgrade = await Swal.fire({
            title: "Are you sure?",
            text: `Do you want to ${plan_type} your plan?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: `Yes, ${plan_type}!`,
            cancelButtonText: "No, Cancel",
        });
    
        if (!confirmUpgrade.isConfirmed) {
            return;
        }
    
        const PlanUpgrade = {
            user_id: user_id,
            plan_id: plan,
            cid: cid,
            downgrade: downgrade
        };
    
        const encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(PlanUpgrade),
            process.env.REACT_APP_SECRETKEY
        ).toString();
    
        const encryptjson = { data: encryptedData };
    
        try {
            const serverURL = process.env.REACT_APP_SERVER_URL;
            const response = await fetch(`${serverURL}/subscription/subscriptionExtendRequest`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    token: token
                },
                body: JSON.stringify(encryptjson)
            });
    
            const responsedata = await response.json();
            const decryptedData = JSON.parse(CryptoJS.AES.decrypt(responsedata.data, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
    
            if (!response.ok) {
                throw new Error(responsedata.error || "Something went wrong");
            }
    
            console.log("Updated Subscription Data:", decryptedData);
    
            decryptedMetadata.plan_id = decryptedData.plan_id;
            // const updatedMetadata = CryptoJS.AES.encrypt(
            //     JSON.stringify(decryptedMetadata),
            //     process.env.REACT_APP_SECRETKEY
            // ).toString();
            // localStorage.setItem("metadata", updatedMetadata);
    
            const confirmSubscription = await Swal.fire({
                title: "Success!",
                text: `Your plan ${plan_type} request has been submitted successfully. Once approved by your admin, you can start using the new plan features.`,
                icon: "success",
                confirmButtonText: "OK",
            });

            if (confirmSubscription.isConfirmed) {
                window.location.reload();
            }
    
        } catch (error) {
            console.log('Error:', error);
    
            Swal.fire({
                title: "Error!",
                text: error.message || "Something went wrong.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };
    
    // useEffect(() => {
    //     const encryptedMetadata = localStorage.getItem('metadata');
    //     const decryptedMetadata = JSON.parse(CryptoJS.AES.decrypt(encryptedMetadata, process.env.REACT_APP_SECRETKEY).toString(CryptoJS.enc.Utf8));
    //     const user_plan = decryptedMetadata.plan_id;
    //     setUserPlan(user_plan);
    // },[])

    // const isDowngradable = downgradablePlan?.some(plan => plan.plan_id === planId);
    const pricingData = [
        { category: "Resume Stored", values: ["200", "1,000", "10,000", "50,000"] },
        { category: "JD's Created", values: ["10", "50", "200", "1,000"] },
        { category: "Email's in Triage", values: ["100", "500", "2,500", "10,000"] },
        { category: "Storage Space", values: ["5GB", "10GB", "50GB", "250GB"] },
        { category: "Upgrade Options", values: ["✅ Allowed", "✅ Allowed", "✅ Allowed", "✅ Enterprise Plans"] },
        { category: "Overage", values: ["❌ Not Allowed", "✅ Allowed", "✅ Allowed", "✅ Allowed"] },
        {
            category: "Actions",
            values: ["",
                <Button disabled={isReqPending} onClick={() => handleUpgradeSubs(2,downGradePlan?.includes("2"))}
                    className={`p-2 !bg-white border-2 ${requestedPlan ? "border-gray-400 text-gray-400" : "border-[#059669] text-[#059669]"} text-sm`}>
                    {requestedPlan === 2 ? "Already Requested" : "Request"} {downGradePlan?.includes("2") ? 'Downgrade' : 'Upgrade'}
                </Button>,
                <Button disabled={isReqPending} onClick={() => handleUpgradeSubs(3,downGradePlan?.includes("3"))}
                    className={`p-2 !bg-white border-2 ${requestedPlan ? "border-gray-400 text-gray-400" : "border-[#059669] text-[#059669]"} text-sm`}>
                    {requestedPlan === 3 ? "Already Requested" : "Request"} {downGradePlan?.includes("3") ? 'Downgrade' : 'Upgrade'}
                </Button>,
                <Button disabled={isReqPending} onClick={() => handleUpgradeSubs(4,downGradePlan?.includes("4"))}
                    className={`p-2 !bg-white border-2 ${requestedPlan ? "border-gray-400 text-gray-400" : "border-[#059669] text-[#059669]"} text-sm`}>
                    {requestedPlan === 4 ? "Already Requested" : "Request"} {downGradePlan?.includes("4")? 'Downgrade' : 'Upgrade'}
                </Button>
            ]
        }
    ];
    
    // let pricingArray=[
    //     ["Resume Stored","200","1,000","10,000","50,000"],
    //     ["JD's Created","10","50","200","1,000"],
    //     ["Email's in Triage","100","500","2,500","10,000"],
    //     ["Storage Space","5GB","10GB","50GB","250GB"],
    //     ["Upgrade Options", "✅ Allowed", "✅ Allowed", "✅ Allowed", "✅ Enterprise Plans"],
    //     ["Overage", "❌ Not Allowed", "✅ Allowed", "✅ Allowed", "✅ Allowed"],
    //     ["","",
    //         <Button disabled={isReqPending} onClick={() => handleUpgradeSubs(2)} className={`p-2 !bg-white border-2 ${requestedPlan ? "border-gray-400 text-gray-400":"border-[#059669] text-[#059669]"} text-sm`}>{requestedPlan ===2 ? "Already Requested" : "Request"} {userPlan > 2 ? 'Downgrade' : 'Upgrade'}</Button>,
    //         <Button disabled={isReqPending} onClick={() => handleUpgradeSubs(3)} className={`p-2 !bg-white border-2 ${requestedPlan ? "border-gray-400 text-gray-400":"border-[#059669] text-[#059669]"}  text-sm`}>{requestedPlan === 3 ? "Already Requested" : "Request"} {userPlan > 3 ? 'Downgrade' : 'Upgrade'}</Button>,
    //         <Button disabled={isReqPending} onClick={() => handleUpgradeSubs(4)} className={`p-2 !bg-white border-2 ${requestedPlan ? "border-gray-400 text-gray-400":"border-[#059669] text-[#059669]"}  text-sm`}>{requestedPlan === 4 ? "Already Requested" : "Request"} {userPlan > 4 ? 'Downgrade' : 'Upgrade'}</Button>,
    //     ]
    // ];
    const [isRequestOpen, setIsRequestOpen] = useState(false);
    const openReqModal = () => {
        console.log(downGradePlan);
        setIsRequestOpen(true);
    }
    const closeReqModal = () => {
        setIsRequestOpen(false);
    }
    const handleRequest = () => {
        Swal.fire({
            title: "Request Submitted!",
            text: "Your credit request has been submitted successfully.",
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "#007bff"
        }).then(() => {
            closeReqModal();
        });
    };    
    return(
        <>
        <RequestModal isOpen={isRequestOpen} onClose={closeReqModal} request={handleRequest} />
        <div className="px-4">
            <div className="p-2 flex justify-center">
              <div>
                <div className="flex justify-center">
                <p className="text-2xl text-black font-[600] mb-1">Flexible Plans for Every Hiring Need</p>
                </div>
                <div className="flex justify-center">
                <p className="text-xs text-black font-[400]">Choose a plan that fits your recruitment goals and scale your hiring effortlessly.</p>
                </div>
              </div> 
            </div>
        
        <div className="w-full px-12 rounded-xl bg-white bg-opacity-50 mt-4">
                <div className="flex lg:justify-center overflow-x-auto">
                    
                <table className="table-auto w-full border-spacing-4">
    <thead>
        <tr className="text-center">
            <th className="px-6 py-3 w-2/12"></th>
            <th className={`px-6 py-3 w-2/12 ${userPlan === 1 ? "border-x-2 border-t-2 border-green-500 rounded-t-lg font-bold" : ""}`}>
                Free Tier(Trial)
                <p className="text-xs text-gray-500 font-light">
                    For companies without specific hiring roles
                </p>
            </th>
            <th className={`px-6 py-3 w-2/12 ${userPlan === 2 ? "border-x-2 border-t-2 border-green-500 rounded-t-lg font-bold" : ""}`}>Bronze
                <p className="text-xs text-gray-500 font-light">For smaller companies hiring at modest salaries</p>
            </th>
            <th className={`px-6 py-3 w-2/12 ${userPlan === 3 ? "border-x-2 border-t-2 border-green-500 rounded-t-lg font-bold" : ""}`}>Silver
                <p className="text-xs text-gray-500 font-light">For most companies looking for good tech talent</p>
            </th>

            <th className={`px-6 py-3 w-2/12 ${userPlan === 4 ? "border-x-2 border-t-2 border-green-500 rounded-t-lg font-bold" : ""}`}>Gold
                <p className="text-xs text-gray-500 font-light">For most larger tech giants looking for excellent tech talent</p>
            </th>
        </tr>
    </thead>
    <tbody>
    {/* {pricingArray.map((row, rowIndex) => (
        <tr key={rowIndex} className={`${rowIndex % 2 !== 0 && rowIndex !== pricingArray.length - 1 ? "bg-[#F2F9F9]" : ""}`}>
            {row.map((cell, colIndex) => {
                const isSelectedPlan = colIndex === userPlan;
                return (
                    <td key={colIndex} className={`px-6 py-3 ${colIndex === 0 ? "text-left" : "text-center"} ${rowIndex === pricingArray.length -1 ? `border-b-2`: ``} ${isSelectedPlan ? "border-x-2 border-green-500 rounded-t-lg font-bold" : ""}`}>
                        {rowIndex === pricingArray.length - 1 && isSelectedPlan ? null : cell}
                    </td>
                );
            })}
        </tr>
    ))} */}
        {pricingData.map((row, rowIndex) => (
        <tr key={rowIndex} className={`${rowIndex % 2 !== 0 && rowIndex !== pricingData.length - 1 ? "bg-[#F2F9F9]" : ""}`}>
            <td className="px-6 py-3 text-left">{row.category}</td>
            {row.values.map((value, colIndex) => {
                const isSelectedPlan = colIndex + 1 === userPlan;
                return (
                    <td key={colIndex} className={`px-6 py-3 text-center ${rowIndex === pricingData.length - 1 ? "border-b-2" : ""} ${isSelectedPlan ? "border-x-2 border-green-500 rounded-t-lg font-bold" : ""}`}>
                        {rowIndex === pricingData.length - 1 && isSelectedPlan ? null : value}
                    </td>
                );
            })}
        </tr>
    ))}
</tbody>

</table>

                    
                </div>
              </div> 
              <div className="flex justify-center">
              <div className="bg-white shadow-md rounded-xl p-4 mt-4 w-9/12 p-4 flex mb-4">
                <div>
                <p className="text-xl font-[600] mb-1">Run Out of Credits?</p>
                <p className="text-xs mb-0">Request 2,000 additional credits to keep your hiring process moving seamlessly.</p>
                </div>
                <div className="ml-auto items-center my-auto">
                    <Button className="p-2 !text-white text-sm" onClick={() => openReqModal()}>Request Credits Now</Button>
                </div>
              </div>
              </div>
              </div>
        </>
    )
}
export default Pricing;